import useLoyaltyUserBenefitView from './useLoyaltyUserBenefitView'
import useUserHasLoyaltyBenefit from './useUserHasLoyaltyBenefit'

/**
 * Returns whether a user has enough remaining benefits to use the type passed in a number of times
 * @param benefitType The benefit type to see if the user can use
 * @param requiredCount How many of the benefit the user needs, e.g. one hotel upgrade per room booked
 * @returns Whether there are enough remaining benefits
 */
function useUserCanApplyLoyaltyBenefit(benefitType: App.LoyaltyBenefitType, requiredCount: number): boolean {
  const hasBenefit = useUserHasLoyaltyBenefit(benefitType)
  const benefit = useLoyaltyUserBenefitView(benefitType)

  return hasBenefit && !!benefit && benefit.availability >= requiredCount
}

export default useUserCanApplyLoyaltyBenefit
